export default __webpack_public_path__ + "d97635ebc4218071a956eb0ed39e2b48.png";